import { tabClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ palette, spacing }) => ({
  studyPlanTabsContainer: {
    padding: spacing(0, 0, 3)
  },
  studyPlanTabs: {
    color: blueGrey[700],

    "& .material-icons": {
      color: blueGrey[500],

      "& path": {
        fill: blueGrey[500]
      }
    },

    "&:hover": {
      "& .material-icons": {
        color: palette.common.white,

        "& path": {
          fill: palette.common.white
        }
      }
    },

    [`&.${tabClasses.selected}`]: {
      "& .material-icons": {
        color: lightBlue[200],

        "& path": {
          fill: lightBlue[200]
        }
      }
    }
  }
}))
